import { __assign } from 'tslib';
import * as React from 'react';
import { useLocalization } from '@shared-ui/localization-context';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-carousel.css';
var getClassNameList = classNames.bind(styles);
var CarouselPaginationDots = function (props) {
  var activeIndex = props.activeIndex,
    changeIndex = props.changeIndex,
    inset = props.inset,
    itemCount = props.itemCount,
    l10n = props.l10n;
  var containerRef = React.createRef();
  var formatText = l10n.formatText;
  // For now setting maximum pagination dots to 5, but this could be made a prop
  var maxDots = 5;
  var baseClassName = 'uitk-carousel-pagination-dots';
  var isAtBeginning = function (currentIndex) {
    if (currentIndex === void 0) {
      currentIndex = activeIndex;
    }
    return currentIndex <= Math.floor(maxDots / 2);
  };
  var isAtEnd = function (currentIndex) {
    if (currentIndex === void 0) {
      currentIndex = activeIndex;
    }
    return currentIndex >= itemCount - 1 - Math.floor(maxDots / 2);
  };
  var calculateStartIndex = function (newActiveIndex) {
    var newStartIndex;
    if (isAtBeginning(newActiveIndex)) {
      newStartIndex = 0;
    } else if (isAtEnd(newActiveIndex)) {
      newStartIndex = itemCount - maxDots;
    } else {
      newStartIndex = activeIndex - Math.floor(maxDots / 2);
    }
    return newStartIndex;
  };
  var _a = React.useState(calculateStartIndex),
    startIndex = _a[0],
    setStartIndex = _a[1];
  // Update starting index whenever active index changes
  React.useEffect(function () {
    setStartIndex(calculateStartIndex());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeIndex]);
  // When updating the start index, scroll horizontally until the start index button is visible
  React.useEffect(function () {
    // Dot width * number of dots to scroll past * space between those dots
    var scrollDistance = 12 * startIndex;
    if (containerRef && containerRef.current) {
      containerRef.current.scrollLeft = scrollDistance;
    }
  }, [containerRef, startIndex]);
  var handleClick = function (e) {
    var _a;
    var clickedIndex = Number((_a = e.currentTarget) === null || _a === void 0 ? void 0 : _a.value);
    calculateStartIndex(clickedIndex);
    changeIndex && changeIndex(clickedIndex);
  };
  var renderDots = function () {
    var _a;
    var paginationDots = [];
    for (var index = 0; index < itemCount; index++) {
      var isFirstDot = index === startIndex;
      var isLastDot = index === startIndex + maxDots - 1;
      var shouldFocus = activeIndex === index;
      // Truncate: if first or last pagination dot AND there are more pages in that direction
      var shouldTruncate = isFirstDot && !isAtBeginning() || isLastDot && !isAtEnd();
      var dotBaseClassName = "".concat(baseClassName, "-icon");
      var dotClassNames = getClassNameList(dotBaseClassName, (_a = {}, _a["".concat(dotBaseClassName, "-focus")] = shouldFocus, _a["".concat(dotBaseClassName, "-truncate")] = shouldTruncate, _a["".concat(dotBaseClassName, "-default")] = !shouldTruncate && !shouldFocus, _a["".concat(dotBaseClassName, "-inset")] = inset, _a["".concat(dotBaseClassName, "-offset")] = !inset, _a));
      var isOutOfView = index < startIndex || index >= startIndex + maxDots;
      paginationDots.push(React.createElement("button", {
        "aria-label": formatText('carousel.indexAndTotal', index + 1, itemCount),
        "aria-hidden": isOutOfView,
        "aria-current": index === activeIndex ? 'location' : false,
        tabIndex: isOutOfView ? -1 : 0,
        type: "button",
        className: getClassNameList("".concat(baseClassName, "-button")),
        onClick: function (e) {
          return handleClick(e);
        },
        key: index,
        value: index
      }, React.createElement("div", {
        className: getClassNameList(dotClassNames),
        "aria-hidden": "true"
      })));
    }
    return paginationDots;
  };
  return React.createElement("div", {
    ref: containerRef,
    className: getClassNameList("".concat(baseClassName, "-container"))
  }, renderDots());
};
var UitkCarouselPaginationDots = function (props) {
  var l10n = useLocalization();
  return React.createElement(CarouselPaginationDots, __assign({
    l10n: l10n
  }, props));
};
UitkCarouselPaginationDots.displayName = 'UitkCarouselPaginationDots';
export { CarouselPaginationDots, UitkCarouselPaginationDots };